import React from "react";
import { useSelector } from 'react-redux';
import { Card, CardContent } from "../../ui/card";
import { List } from 'react-content-loader'
import { Info } from "lucide-react";

const AISummary = () => {
  const { aiResponse, fetchAiResponseLoading } = useSelector(state => state.UserStatus);

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-3">
          <Info className="h-5 w-5 text-indigo-500" />
          <h3 className="font-semibold text-lg">
            AI-Generated Summary
          </h3>
        </div>
        <p className="text-sm text-gray-700">
          {fetchAiResponseLoading && (<List height={110} />)}
          {!fetchAiResponseLoading && (
            <div
              className="ai-response-data"
              dangerouslySetInnerHTML={{ __html: aiResponse?.ai_response }}
            />
          )}
        </p>
      </CardContent>
    </Card>
  );
};

export default AISummary;
